import axios from '@/libs/api.request'

export const getAllSuppliers = (partIds) => {
  return axios.request({
    url: `pricing/suppliers`,
    method: 'get',
    params: {
      manufacturer_part_ids: partIds
    }
  })
}

export const loadModelParams = (costId) => {
  return axios.request({
    url: `pricing/${costId}/model-params`,
    method: 'get'
  })
}

export const makePriceSuggestion = (costId, data) => {
  return axios.request({
    url: `pricing/${costId}/make-suggestion`,
    data: data,
    method: 'post'
  })
}
